export const GET_EVENT_LOGGING_DETAILS = 'GET_EVENT_LOGGING_DETAILS';
export const SERVICE_ERROR = 'SERVICE_ERROR';
